import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=479100f4&scoped=true"
import script from "./firstStep.vue?vue&type=script&lang=js"
export * from "./firstStep.vue?vue&type=script&lang=js"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=479100f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479100f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479100f4')) {
      api.createRecord('479100f4', component.options)
    } else {
      api.reload('479100f4', component.options)
    }
    module.hot.accept("./firstStep.vue?vue&type=template&id=479100f4&scoped=true", function () {
      api.rerender('479100f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformActivity/components/firstStep.vue"
export default component.exports